import { store } from "./store/store";

import Shell from "./pages/Shell";
import Home from "./pages/Home";
import FreePicks from "./pages/FreePicks";
import Package from "./pages/Package";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Register from "./pages/Register";
import Testimonials from "./pages/Testimonials";
import PaymentSuccess from "./pages/PaymentSuccess";
// import Results from './pages/Results'
import Blog from "./pages/Blog";
import ViewPicks from "./pages/ViewPicks";
import MyAccount from "./pages/MyAccount";
import ChangePassword from "./pages/ChangePassword";
import Disclaimer from "./pages/Disclaimer";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ForgotPassword from "./pages/ForgotPassword";
import Odds from "./pages/Odds";
import Purchase from "./pages/Purchase";
import BetSizing from "./pages/tools/BetSizing";

// Shop pages
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import MyOrders from "./pages/MyOrders";

// Admin pages
import Admin from "./pages/Admin";
import Pick from "./pages/admin/Pick";
import Testimonial from "./pages/admin/Testimonial";
import ManageTestimonials from "./pages/admin/ManageTestimonial";
import ManagePicks from "./pages/admin/ManagePicks";
import ManageRecord from "./pages/admin/ManageRecord";
import ManagePackages from "./pages/admin/ManagePackages";
import ManageCategories from "./pages/admin/ManageCategories";
import ManagePosts from "./pages/admin/ManagePosts";
import EditRecord from "./pages/admin/EditRecord";
import EditPackage from "./pages/admin/EditPackage";
import EditCategory from "./pages/admin/EditCategory";
import EditPost from "./pages/admin/EditPost";
import AdminUsers from "./pages/admin/Users";
import AdminEditUser from "./pages/admin/EditUser";
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// Vue.extend(), or just a component options object.
export const routes = [
  {
    path: "/",
    component: Shell,
    children: [
      {
        path: "/",
        component: Home,
        name: "home",
      },
      {
        path: "/freepicks",
        component: FreePicks,
        name: "freepicks",
        meta: {
          breadcrumb: "Free Picks Blog",
          subtitle: "Free Picks Blog",
        },
      },
      {
        path: "/packages/:sport",
        component: Package,
        name: "package",
        meta: {
          breadcrumb: "Packages",
          subtitle: "Packages",
        },
      },
      {
        path: "/faq",
        component: Faq,
        name: "faq",
        meta: {
          breadcrumb: "FAQ",
          subtitle: "FAQ",
        },
      },
      {
        path: "/contact",
        component: Contact,
        name: "contact",
        meta: {
          breadcrumb: "Contact",
          subtitle: "Contact",
        },
      },
      {
        path: "/register",
        component: Register,
        name: "register",
        meta: {
          breadcrumb: "Register",
          subtitle: "Register",
        },
      },
      {
        path: "/testimonials",
        component: Testimonials,
        name: "testimonials",
        meta: {
          breadcrumb: "Testimonials",
          subtitle: "Testimonials",
        },
      },
      {
        path: "/paymentsuccess",
        component: PaymentSuccess,
        name: "payment_success",
      },
      {
        path: "/odds",
        component: Odds,
        name: "odds",
        // meta: {breadcrumb: 'Odds', subtitle: 'View Odds'}
      },
      {
        path: "/purchase",
        component: Purchase,
        name: "purchase",
      },
      // {path: '/results', component: Results, name: 'results', meta: {breadcrumb: 'Result L5 Days', subtitle: 'View Results'}},
      {
        path: "/blog",
        component: Blog,
        name: "blog",
        meta: {
          breadcrumb: "Blog",
          subtitle: "Blog",
        },
      },
      {
        path: "/viewpicks",
        component: ViewPicks,
        name: "picks",
        meta: {
          breadcrumb: "Premium Picks",
          subtitle: "View Premium Picks",
        },
        beforeEnter: (to, from, next) => {
          if (!isPremium()) {
            return next("/packages/all");
          } else next();
        },
      },
      {
        path: "/myaccount",
        component: MyAccount,
        name: "myaccount",
        meta: {
          breadcrumb: "My Account",
          subtitle: "My Account",
        },
        beforeEnter: (to, from, next) => isLoggedIn(next),
      },
      {
        path: "/changepassword",
        component: ChangePassword,
        name: "changepassword",
        meta: {
          breadcrumb: "My Account",
          subtitle: "Change Password",
        },
      },
      {
        path: "/disclaimer",
        component: Disclaimer,
        name: "disclaimer",
        meta: {
          breadcrumb: "Disclaimer",
          subtitle: "Disclaimer",
        },
      },
      {
        path: "/privacy",
        component: Privacy,
        name: "privacy",
        meta: {
          breadcrumb: "Privacy",
          subtitle: "Privacy",
        },
      },
      {
        path: "/terms",
        component: Terms,
        name: "termsofuse",
        meta: {
          breadcrumb: "Terms of Use",
          subtitle: "Terms of Use",
        },
      },
      {
        path: "/forgotpassword",
        component: ForgotPassword,
        name: "forgotpassword",
        meta: {
          breadcrumb: "Home",
          subtitle: "Forgot Password",
        },
      },
      {
        path: "/tools/size",
        component: BetSizing,
        name: "betsizing",
        meta: {
          breadcrumb: "Home",
          subtitle: "Bet Sizing Calculator",
        },
      },

      // Shop routes
      {
        path: "/shop",
        component: Shop,
        name: "shop",
        meta: {
          breadcrumb: "Shop",
          subtitle: "Shop",
        },
      },
      {
        path: "/shop/:slug",
        component: ProductDetail,
        name: "productdetail",
        meta: {
          breadcrumb: "Product Detail",
          subtitle: "Product Detail",
        },
      },
      {
        path: "/cart",
        component: Cart,
        name: "cart",
        meta: {
          breadcrumb: "Shopping Cart",
          subtitle: "Shopping Cart",
        },
      },
      {
        path: "/checkout",
        component: Checkout,
        name: "checkout",
        meta: {
          breadcrumb: "Checkout",
          subtitle: "Checkout",
        },
        beforeEnter: (to, from, next) => isLoggedIn(next),
      },
      {
        path: "/order-confirmation/:orderId",
        component: OrderConfirmation,
        name: "orderconfirmation",
        meta: {
          breadcrumb: "Order Confirmation",
          subtitle: "Order Confirmation",
        },
        beforeEnter: (to, from, next) => isLoggedIn(next),
      },
      {
        path: "/my-orders",
        component: MyOrders,
        name: "myorders",
        meta: {
          breadcrumb: "My Orders",
          subtitle: "My Orders",
        },
        beforeEnter: (to, from, next) => isLoggedIn(next),
      },

      {
        path: "/admin",
        component: Admin,
        name: "admin",
        meta: {
          breadcrumb: "Admin",
          subtitle: "Admin",
        },
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/pick/:id?",
        component: Pick,
        name: "adminpick",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/picks",
        component: ManagePicks,
        name: "admin_manage_picks",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/testimonial/:id?",
        component: Testimonial,
        name: "admin_testimonial",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/testimonials",
        component: ManageTestimonials,
        name: "admin_manage_testimonials",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/record",
        component: ManageRecord,
        name: "admin_manage_record",
        meta: {
          breadcrumb: "Admin",
          subtitle: "Manage Record",
        },
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/categories",
        component: ManageCategories,
        name: "admin_manage_categories",
        meta: {
          breadcrumb: "Admin",
          subtitle: "Manage Categories",
        },
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/record/:id",
        component: EditRecord,
        name: "admin_edit_record",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/package",
        component: ManagePackages,
        name: "admin_manage_packages",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "admin/posts",
        component: ManagePosts,
        name: "admin_manage_posts",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/package/:id",
        component: EditPackage,
        name: "admin_edit_package",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/categories/:id",
        component: EditCategory,
        name: "admin_edit_category",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/posts/:id",
        component: EditPost,
        name: "admin_edit_post",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/users/",
        component: AdminUsers,
        name: "admin_users",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
      {
        path: "/admin/users/edit",
        component: AdminEditUser,
        name: "admin_edit_user",
        beforeEnter: (to, from, next) => checkAdmin(next),
      },
    ],
  },
];

function isAdmin() {
  return store.state.currentUser && store.state.currentUser.admin;
}

function isPremium() {
  return store.state.currentUser && store.state.currentUser.premium;
}

function isLoggedIn(next) {
  if (!store.state.currentUser) next("/");
  else next();
}

function checkAdmin(next) {
  if (!isAdmin()) next("/");
  else next();
}



// WEBPACK FOOTER //
// ./src/routes.js